// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2Kjap","content":"LayoutSettings_content__2kq4D"};